import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '../components/ui/Button';
// הסיסמה המוגדרת (בפרודקשן, זה צריך להיות בצד שרת)
const ADMIN_PASSWORD = 'BeachClub2024!';
export function AdminLogin() {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      // שמירת סטטוס התחברות ב-localStorage
      localStorage.setItem('adminAuthenticated', 'true');
      navigate('/admin');
    } else {
      setError('סיסמה שגויה');
      setPassword('');
    }
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center px-4" dir="rtl" data-id="element-920">
      <div className="max-w-md w-full" data-id="element-921">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-922">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-923">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4" data-id="element-924">
              <Lock className="w-8 h-8 text-blue-600" data-id="element-925" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-926">
              כניסה לפאנל ניהול
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-927">
              הזן את הסיסמה כדי לגשת לדף הניהול
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-928">
            <div data-id="element-929">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-930">
                סיסמה
              </label>
              <div className="relative" data-id="element-931">
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setError('');
              }} className="block w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" placeholder="הזן סיסמה" required data-id="element-932" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-933">
                  {showPassword ? <EyeOff className="w-5 h-5" data-id="element-934" /> : <Eye className="w-5 h-5" data-id="element-935" />}
                </button>
              </div>
              {error && <p className="mt-2 text-sm text-red-600 flex items-center gap-1" data-id="element-936">
                  <span className="inline-block w-1 h-1 bg-red-600 rounded-full" data-id="element-937"></span>
                  {error}
                </p>}
            </div>

            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors" data-id="element-938">
              כניסה
            </Button>
          </form>

          {/* Info */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg" data-id="element-939">
            <p className="text-xs text-blue-800 text-center" data-id="element-940">
              🔒 הסיסמה הזמנית:{' '}
              <span className="font-mono font-bold" data-id="element-941">BeachClub2024!</span>
            </p>
            <p className="text-xs text-blue-600 text-center mt-1" data-id="element-942">
              (מומלץ לשנות את הסיסמה בקוד)
            </p>
          </div>
        </div>

        {/* Back to site */}
        <div className="text-center mt-6" data-id="element-943">
          <a href="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-944">
            ← חזרה לאתר
          </a>
        </div>
      </div>
    </div>;
}